export default __webpack_public_path__ + "static/media/purgatoryEmpty.9f4e3848.webp";